import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {
    Popover,Position,
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class TeamPlayer extends Component {
    
  render() {
    return (
        <li className="col">
            <Popover position={Position.RIGHT} className="team_pop">
              <div className="cursor_link">
              <img className="team_player_img" src={this.props.image}/>
              <div className="team_player_name">{this.props.name}</div>
            <div className="team_role">{this.props.role}</div>
              </div>
          <div className="team_popover">
            <h3>{this.props.name} &mdash; {this.props.role}</h3>
            <p className="team_player_desc">{this.props.desc}</p>
          </div>
        </Popover>
           
            {/*<p className="team_player_desc">{this.props.desc}</p>*/}
        </li>
    );
  }
}

export default TeamPlayer;